<template>
    <div class="lightGrey">

        <img class="w-100 db" src="@/assets/img/landing/divider_rough_edge_bottom.svg">

        <!-- nearby tools -->
        <div class="container">
            <div class="col-xs-12 mb3">
                <h2 class="mt5">Nearby tools that you might need.</h2>
            </div>

            <HugeSpinner v-if="loadingNearbyListings"/>
            <div v-else class="row">
                <div v-for="(listing, index) in nearbyListings" :key="index"  class="col-xs-6 col-sm-4 col-md-3">
                    <NearbyToolCard :listing="listing" :image="require(`@/assets/img/category_automotive.jpg`)"/>
                </div>
            </div>
        </div>

        <div class="mt5 bt b--mid-gray pb5"></div>
    
        <!-- browse by project -->
        <div class="container">
            <div class="col-xs-12 mb3">
                <h2>Browse by project to find what you need.</h2>
            </div>
            <div class="row pb6">
                <div v-for="(project, index) in projects" :key="index" class="col-xs-6 col-sm-4 col-md-3">
                    <ProjectCard  class="mb2" :image="project.image" :category="project.category"/>
                </div>
            </div>

        </div>

        <img class="w-100 db" src="@/assets/img/landing/divider_clouds.svg">
       
    </div>
</template>

<script>
import ProjectCard from '@/components/landing/ProjectCard.vue';
import NearbyToolCard from '@/components/landing/NearbyToolCard.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
            projects: [
                {
                    image: require(`@/assets/img/category_seasonal.jpg`),
                    category: 'Seasonal'
                },
                {
                    image: require(`@/assets/img/category_excavating.jpg`),
                    category: 'Excavating'
                },
                {
                    image: require(`@/assets/img/category_agriculture.jpg`),
                    category: 'Agriculture'
                },
                {
                    image: require(`@/assets/img/category_automotive.jpg`),
                    category: 'Automotive'
                },
                {
                    image: require(`@/assets/img/category_building.jpg`),
                    category: 'Building'
                },
                {
                    image: require(`@/assets/img/category_lighting.jpg`),
                    category: 'Lighting'
                },
                {
                    image: require(`@/assets/img/category_roofing.jpg`),
                    category: 'Roofing'
                },
                {
                    image: require(`@/assets/img/category_drywalling.jpg`),
                    category: 'Drywalling'
                },
                {
                    image: require(`@/assets/img/category_electrical.jpg`),
                    category: 'Electrical'
                },
                {
                    image: require(`@/assets/img/category_plumbing.jpg`),
                    category: 'Plumbing'
                },
                {
                    image: require(`@/assets/img/category_flooring.jpg`),
                    category: 'Flooring'
                },
                {
                    image: require(`@/assets/img/category_painting.jpg`),
                    category: 'Painting'
                },
                {
                    image: require(`@/assets/img/category_finishing.jpg`),
                    category: 'Finishing'
                },
                {
                    image: require(`@/assets/img/category_landscaping.jpg`),
                    category: 'Landscaping'
                },
                {
                    image: require(`@/assets/img/category_yardwork.jpg`),
                    category: 'Yardwork'
                }
            ]
        };
    },
    components: {
        ProjectCard,
        NearbyToolCard,
        HugeSpinner
    },
    computed: {
        smallOrLess() {
            return this.$mq === 'xs' || this.$mq === 'sm';
        },
        ...mapState('listings', ['nearbyListings', 'loadingNearbyListings'])
    },
    methods: {
        ...mapActions('listings', ['getNearbyListings'])
    },
    created: function() {
        this.getNearbyListings();
    }
};
</script>

<style scoped>
.lightGrey {
    background-image: url('../../assets/img/tooliaba_seemless_texture_1.jpg');
    background-repeat: repeat;
}
</style>
